import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <Box h={"100vh"} pt={5} pb={10} px={10} position={"relative"}>
      <Outlet />
    </Box>
  );
};

export default Layout;
